<template>
    <div class="container mx-auto px-3 pb-32 md:px-8 font-sans max-w-(--breakpoint-xl)">
        <h1 class="sr-only">Dashboard</h1>

        <div class="grid grid-cols-12 gap-x-6 gap-y-2 md:gap-y-8">
            <div class="col-span-12 md:col-span-8 lg:col-span-8 grid items-stretch">
                <home-call-to-action></home-call-to-action>
            </div>
            <div class="col-span-12 md:col-span-4 lg:col-span-4">
                <home-features></home-features>
            </div>

            <home-recently-created-campaigns class="col-span-12"></home-recently-created-campaigns>

            <home-analytics v-if="canSeeAnalytics"></home-analytics>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import HomeCallToAction from './HomeCallToAction.vue';
import HomeFeatures from './HomeFeatures.vue';
import HomeAnalytics from './HomeAnalytics.vue';
import HomeRecentlyCreatedCampaigns from './HomeRecentlyCreatedCampaigns.vue';
import { hasScope } from '../../utils/users';

const canSeeAnalytics = computed(() => hasScope('analytics:read'));
</script>
